import { Navigate, Outlet, useNavigate } from 'react-router';
import Header from '../../shared/components/header/Header';
import Footer from '../../shared/components/footer/Footer';
import './product-layout.css';
import { useAuth } from '../auth/hooks/useAuth';
import { TLoggedInUserInfo } from '../../shared/types/loggedInUserInfo';
import { Spinner } from '@heroui/react';
import { useEffect, useState } from 'react';
import axiosInstance from '../../shared/api/axiosInstance';

interface IProductLayoutProps  {
    showSnackbar: boolean // Replace 'unknown' with the correct type, e.g., '() => void' or 'boolean'    
};

const ProductLayout = ({ showSnackbar }: IProductLayoutProps) => {
    
    const [loggedInUserInfo, setLoggedInUserInfo] = useState<TLoggedInUserInfo | null>(null);
    const navigate = useNavigate();
    const { isAuthenticated, isLoading } = useAuth();

     useEffect(() => {

        if (isAuthenticated && loggedInUserInfo === null) {
            axiosInstance.get('/token/userinfo', { withCredentials: true })
                .then((response) => {
                    if (!response.data) {
                        navigate('/account/login', { replace: true });
                    }
                    else {
                        setLoggedInUserInfo(response.data);
                    }

                })
                .catch((error) => {
                    navigate('/error', { replace: true });
                    console.error("Error fetching user info:", error);
                });
        }

    }, [isAuthenticated, loggedInUserInfo, navigate]);

    if (!isLoading && !loggedInUserInfo && !isAuthenticated) {
        return <Navigate to="/account/login" />;
    }
    
    return (
        <div className="flex flex-col h-screen product-layout-container">
            <header className='shrink-0'>
                <Header loggedInUserInfo={loggedInUserInfo} />
            </header>

            <main className="flex-1 overflow-auto z-10">
                {isAuthenticated && loggedInUserInfo && !showSnackbar ?
                    <Outlet context={loggedInUserInfo} /> :
                    <div className=' flex h-full w-full justify-center items-center'>
                        <Spinner size='lg' label={showSnackbar ? "Application is reloading" : "Loading"} classNames={{ label: "text-md" }} variant="simple" />
                    </div>}
            </main>

            <footer className="shrink-0 ">
                <Footer />
            </footer>
        </div>
    );

}
export default ProductLayout;